export class SimpleAsyncProducerConsumer {

    private _referenceCount: number = 0;

    private readonly _provider: () => Promise<any>;

    private _cache: Promise<any>| null;

    /**
     *
     * @param {} provider
     */
    public constructor( provider: () => Promise<any> ) {

        this._provider = provider;

        this._cache = null;

    }

    public cachedGet(): Promise<any> {

        if ( this._cache !== null ) {

            return this._cache;

        }

        return this.forceGet();

    }

    public consumeGet(): Promise<any> {

        if ( this._cache !== null ) {

            const result = this._cache;
            const referenceCount = this._referenceCount;
            // clear
            if ( typeof referenceCount === 'number' && this._referenceCount > 0 ) {

                this._referenceCount--;
                if ( this._referenceCount === 0 ) {

                    this._cache = null;

                }

            }
            return result;

        }
        return this.forceGet();

    }

    public forceGet(): Promise<any> {

        return this._provider();

    }

    public providerGet( referenceCount = 0 ): Promise<any> {

        const rt = this.forceGet();

        if ( typeof referenceCount === 'number' && referenceCount > 0 ) {

            this._cache = rt;
            this._referenceCount = referenceCount;

        }

        return rt;

    }

}
